export default {
  selectedPlanState: state => state.selectedPlan,
  myPlanState: state => state.myPlan,
  invoicePlanState: state => state.invoicePlan,
  selectedModuleForPlanState: state => state.selectedModuleForPlan
}
